import { Navigate, useTypedParams } from '@sorare/routing';
import { ANY_SPORT_SERIES_MY_CARDS_GALLERY_RARITY_SET } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import type { PageParams } from './__generated__/routeParams.ts';

const GalleryRaritySetPage = () => {
  const { rarity, set } = useTypedParams<PageParams>();
  const { generateSportContextPath } = useSportContext();

  return (
    <Navigate
      to={generateSportContextPath(
        ANY_SPORT_SERIES_MY_CARDS_GALLERY_RARITY_SET,
        {
          params: {
            rarity,
            set,
          },
        }
      )}
      replace
    />
  );
};
export default GalleryRaritySetPage;
